import { createStore } from 'vuex';
import user from './user.store';
import request from './request.store';
import general from './general.store';
import activityLogs from './activity-logs.store';

export const store = createStore({
  actions: {
    async initApp({ rootState, dispatch }) {
      if (!rootState.request.requests.length) {
         dispatch('request/initRequests', { root: true });
      }
      
      if (!rootState.general.generalList.length) {
         dispatch('general/initGeneralList', { root: true });
      }

      if (!rootState.user.allUsers.length) {
         dispatch('user/initAllUsers', { root: true });
      }
    }
  },

  modules: {
    user,
    request,
    general,
    activityLogs
  }
});